import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("fc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Globaler 401-Handler: ungültige/entzogene Sitzung sauber beenden (kein kaputter Zustand).
// Login-/Auth-Aufrufe ausgenommen (dort ist 401 = falsche Zugangsdaten und wird lokal behandelt).
api.interceptors.response.use(
  (r) => r,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || "";
    if (status === 401 && !url.includes("/auth/") && localStorage.getItem("fc_token")) {
      localStorage.removeItem("fc_token");
      if (typeof window !== "undefined" && window.location.pathname.startsWith("/app")) {
        window.location.href = "/anmelden?sitzung=abgelaufen";
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Etwas ist schiefgelaufen. Bitte erneut versuchen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  if (detail && typeof detail.message === "string") return detail.message;
  return String(detail);
}

export default api;
